var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDbSeekFacturation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,0C114.8,0,0,114.8,0,256s114.8,256,256,256s256-114.8,256-256S397.2,0,256,0z M256,480 C132.5,480,32,379.5,32,256S132.5,32,256,32s224,100.5,224,224S379.5,480,256,480z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311,339.7c-11.9,8.1-25,12.3-39,12.3c-29.5,0-55-19.5-68.9-48H256c8.8,0,16-7.2,16-16s-7.2-16-16-16h-62.7 c-0.7-5.2-1.3-10.5-1.3-16s0.6-10.8,1.3-16H272c8.8,0,16-7.2,16-16s-7.2-16-16-16h-68.9c13.9-28.5,39.4-48,68.9-48 c14,0,27.1,4.1,39,12.3c7.3,5,17.3,3.1,22.2-4.2c5-7.3,3.1-17.2-4.2-22.2c-17.1-11.6-36.8-17.8-57-17.8c-46.9,0-87,33.2-103.7,80 H144c-8.8,0-16,7.2-16,16s7.2,16,16,16h17.4c-0.6,5.3-1.4,10.5-1.4,16c0,5.5,0.8,10.7,1.4,16H144c-8.8,0-16,7.2-16,16 s7.2,16,16,16h24.3c16.7,46.8,56.8,80,103.7,80c20.2,0,39.9-6.2,57-17.8c7.3-5,9.2-14.9,4.2-22.2 C328.3,336.6,318.3,334.8,311,339.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbSeekFacturation);
export default __webpack_public_path__ + "static/media/DB-seek-facturation.8e702535feae2f871c8a594821d5dfea.svg";
export { ForwardRef as ReactComponent };